import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { Scrollbars } from "react-custom-scrollbars";
import classNames from "classnames";

import { RectangleSpinner } from "../../common/spinners";
import { DataTable } from "../../common/DataTable";

import { getEnvironmentProperties } from "../../common/environmentProperties";

const SearchResults = (props) => {
    const { clients, members } = props;

    const setCellClassNames = (row) => {
        return classNames({
            archived: row.isArchived,
        });
    };

    clients.cols = [
        {
            name: <FormattedMessage id="clients.datatable.columns.name" />,
            key: "client_fts.name",
            widthPct: 30,
            display: (client) => (
                <span className={setCellClassNames(client)}>
                  <a href={`/dashboard/clients/${client.clientId}`} title={client.name} onClick={props.close}>{client.name}</a>
                </span>
            ),
        },
        {
            name: <FormattedMessage id="clients.datatable.columns.fullName" />,
            key: "client_fts.full_name",
            widthPct: 100,
            display: (client) => (
                <span className={setCellClassNames(client)}>
                    <a href={`/dashboard/clients/${client.clientId}`} title={client.name} onClick={props.close}>{client.fullName}</a>
                </span>
            ),
        },
    ];

    members.cols = [
        {
            name: <FormattedMessage id="search.datatables.members.name" />,
             sortKeys: ["members_client_fts.unaccented_member_first_name", "members_client_fts.unaccented_member_last_name"],
            widthPct: 20,
            display: (member) => (
                <span className={setCellClassNames(member)}>
                  <a href={`/dashboard/clients/${member.clientId}/members/${member.memberId}`} title={member.memberFirstName + " " + member.memberLastName} onClick={props.close}>
                  {member.memberFirstName} {member.memberLastName}</a>
                </span>
            ),
        },
        {
            name: <FormattedMessage id="members.datatable.columns.memberIdentifier" />,
            key: "members_client_fts.member_identifier",
            widthPct: 20,
            display: (member) => (
                <span className={setCellClassNames(member)}>
                  <a href={`/dashboard/clients/${member.clientId}/members/${member.memberId}`} title={member.memberIdentifier} onClick={props.close}>
                  {member.memberIdentifier}</a>
                </span>
            ),
        },
        {
            name: <FormattedMessage id="search.datatables.members.client" />,
            key: "members_client_fts.client_name",
            widthPct: 30,
            display: (member) => (
                <span className={setCellClassNames(member)}>
                  <a href={`/dashboard/clients/${member.clientId}/members/${member.memberId}`} title={member.clientName} onClick={props.close}>
                  {member.clientName}</a>
                </span>
            ),
        },
        {
            name: <FormattedMessage id="clients.datatable.columns.fullName" />,
            key: "members_client_fts.client_full_name",
            widthPct: 100,
            display: (member) => (
                <span className={setCellClassNames(member)}>
                  <a href={`/dashboard/clients/${member.clientId}/members/${member.memberId}`} title={member.clientFullName} onClick={props.close}>
                  {member.clientFullName}</a>
                </span>
            ),
        },
    ];

  const { displayEnvironmentOnScreen } = getEnvironmentProperties();
  const nonProdBannerOffset = displayEnvironmentOnScreen ? "banner-offset" : ""; 
  return (
    <div className={`search-results ${nonProdBannerOffset}`}>
      <div className="search-header">
        <div className="close" onClick={props.close} />
        <h1>
          <FormattedMessage id="search.title" />
        </h1>
      </div>
      <Scrollbars
        autoHide={true}
        renderThumbVertical={({ ...props }) => (
          <div {...props} className="scrollbars" />
        )}
        renderView={({ ...props }) => <div {...props} className="scrollarea" />}
      >
        {(clients.fetching || members.fetching) && <RectangleSpinner />}
        <div
          style={{
            display: clients.fetching || members.fetching ? "none" : "block",
          }}
        >
          {!!clients.items && !!clients.items.length && (
            <div>
              <h2>
                <FormattedMessage id="clients.title" />
              </h2>
              <DataTable
                cols={clients.cols}
                data={clients.items}
                getData={props.searchClients}
                offset={clients.pagination.offset}
                showFilters={false}
                rowsPerPage={clients.pagination.limit}
                sortBy={clients.sortBy}
                totalRows={clients.pagination.totalCount}
              />
            </div>
          )}
          {!!members.items && !!members.items.length && (
            <div>
              <h2>
                <FormattedMessage id="members.title" />
              </h2>
              <DataTable
                cols={members.cols}
                data={members.items}
                getData={props.searchMembers}
                offset={members.pagination.offset}
                showFilters={false}
                rowsPerPage={members.pagination.limit}
                sortBy={members.sortBy}
                totalRows={members.pagination.totalCount}
              />
            </div>
          )}
          {!!clients.items &&
            !clients.items.length &&
            !!members.items &&
            !members.items.length && (
              <div className="no-results">
                <FormattedMessage id="search.noResults" />
              </div>
            )}
        </div>
      </Scrollbars>
    </div>
  );
};

SearchResults.propTypes = {
  close: PropTypes.func.isRequired,
  clients: PropTypes.object.isRequired,
  members: PropTypes.object.isRequired,
  searchClients: PropTypes.func.isRequired,
  searchMembers: PropTypes.func.isRequired,
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/dashboard/search/SearchResults.js